import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, EyeOffIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/pixel';
export function Offer() {
  return <section id="offer" className="py-16 md:py-24 px-5 bg-[#F2EBE1]" data-id="element-124">
      <div className="max-w-2xl mx-auto bg-white p-6 sm:p-10 md:p-14 shadow-xl border-t-4 border-[#5C1A2B] text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-126">
          <h2 className="font-serif text-3xl md:text-4xl text-[#5C1A2B] mb-4 leading-tight" data-id="element-127">
            No le regales otro minuto.
          </h2>

          <p className="text-base md:text-lg text-[#4A4A4A] font-light mb-8 leading-relaxed" data-id="element-128">
            Tu libertad está a un clic.
          </p>

          <div className="mb-8" data-id="element-129">
            <span className="text-5xl md:text-6xl font-serif text-[#2D2D2D] block mb-2" data-id="element-130">
              $89 MXN
            </span>
            <span className="text-xs text-[#8A8A8A] uppercase tracking-widest" data-id="element-131">
              Pago único · Acceso inmediato
            </span>
          </div>

          <a href="https://serenopulse.com/cart/47935901401346:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="block w-full bg-[#C86B5E] hover:bg-[#b05a4e] text-white font-medium py-5 px-8 tracking-wider uppercase text-xs sm:text-sm transition-all duration-300 shadow-lg shadow-[#C86B5E]/20 hover:shadow-[#C86B5E]/40 mb-6" data-id="element-132">
            ¡Basta de migajas, quiero mi dignidad!
          </a>

          <div className="grid grid-cols-3 gap-3 text-[10px] sm:text-xs text-[#8A8A8A] uppercase tracking-wider" data-id="element-133">
            <div className="flex flex-col items-center gap-1" data-id="element-134">
              <ZapIcon className="w-4 h-4" data-id="element-135" />
              <span data-id="element-136">Inmediato</span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-137">
              <LockIcon className="w-4 h-4" data-id="element-138" />
              <span data-id="element-139">Compra segura</span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-140">
              <EyeOffIcon className="w-4 h-4" data-id="element-141" />
              <span data-id="element-142">Discreto</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}